import { render, staticRenderFns } from "./ShowTeams.vue?vue&type=template&id=0f36e315"
import script from "./ShowTeams.vue?vue&type=script&lang=js"
export * from "./ShowTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports